import React from 'react';
import * as PropTypes from 'prop-types';
import { getDateFRFromYYYYMMDDHHMMSS } from 'components/Commun/Form/Date/dateTranformation';
import { CardV2, CardBody, CardContent, Col, Row } from '@si-armes/dsfr-react';
import styles from './InformationsCeaf.module.scss';
import { CEAF } from '../../../constants/accessibilite.constants';

const InformationsCeaf = ({ informationsCeaf }) => {
    const { dateInit, dateExpiration, dateMaj, statut } = informationsCeaf;
    return (
        <>
            <CardV2 taille="lg" noEnlargeLink>
                <CardBody>
                    <CardContent>
                        <div className={styles.informationsCeaf}>
                            <div className={styles.informationsCeaf__informations}>
                                <Row>
                                    <Col col={12}>
                                        <div
                                            className={styles.informationsCeaf__informations__titre}
                                        >
                                            <span
                                                className="fr-icon-file-fill icon-color"
                                                aria-hidden="true"
                                            />{' '}
                                            <abbr>{CEAF}</abbr>
                                        </div>
                                    </Col>
                                </Row>
                                <div className={styles.informationsCeaf__informations__line}>
                                    G&eacute;n&eacute;r&eacute;e le :{' '}
                                    {getDateFRFromYYYYMMDDHHMMSS(dateInit)}
                                </div>

                                {informationsCeaf && statut === 'Expirée' ? (
                                    <div
                                        className={
                                            styles.informationsCeaf__informations__titreAlerte
                                        }
                                    >
                                        <abbr>{CEAF}</abbr> expirée le{' '}
                                        {getDateFRFromYYYYMMDDHHMMSS(dateMaj)}
                                    </div>
                                ) : (
                                    <div
                                        className={
                                            styles.informationsPersonnelles__informations__line
                                        }
                                    >
                                        Valable jusqu&apos;au :{' '}
                                        {getDateFRFromYYYYMMDDHHMMSS(dateExpiration)}
                                    </div>
                                )}
                            </div>
                        </div>
                    </CardContent>
                </CardBody>
            </CardV2>
        </>
    );
};

InformationsCeaf.propTypes = {
    informationsCeaf: PropTypes.shape({
        statut: PropTypes.string.isRequired,
        dateExpiration: PropTypes.string.isRequired,
        numeroCeaf: PropTypes.string.isRequired,
        dateInit: PropTypes.string.isRequired,
        dateMaj: PropTypes.string.isRequired,
        expiree: PropTypes.bool.isRequired,
    }).isRequired,
};

export default InformationsCeaf;
